import React from 'react'
import './styles/Career.scss'

function Career() {
    return (
        <div className="career-container main-text block added-shadow added-shadow--var2">
            <h2>Карьера в Кибернетика</h2>
            <p>
                ТОО "Кибернетика.com" - IT- компания предлагающая решение по оптимизации и автоматизации бизнес-процессов на базе 1С. Миссия компании "Научить
                компьютеры помогать людям". Внутри компании ценим экологичность отношений и ответственность. У нас уже немаленькая команда которая состоит из
                программистов 1С , консультантов и специалистов по Optimacros, также стажеров, лучшие из них попадают в команду.
            </p>
            <div>
                <h3>Мы предоставляем услуги:</h3>
                <ul>
                    <li>Доработка типовых и нетиповых конфигураций</li>
                    <li>Внедрение ERP системы 1С-Интеграция систем</li>
                    <li>Поддержка и сопровождение систем</li>
                </ul>
            </div>
            <p>
                Мы поощряем наших сотрудников мыслить свежо, быть креативными и искать новые пути решения проблем. Мы поддерживаем инициативу и приветствуем
                новые идеи, которые способствуют росту и развитию компании.
            </p>
            <p>
                <span className="main-text--bold">Отдел HR: </span>
                <a href="tel:+77718000768" className="main-text">
                    +7 771 800 07 68
                </a>
            </p>
        </div>
    )
}

export default Career
